import { render, staticRenderFns } from "./CardFront.vue?vue&type=template&id=67142c07&"
import script from "./CardFront.vue?vue&type=script&lang=js&"
export * from "./CardFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports